import * as config from "../config.js";

export const getSupportingContent = async (supportingContentID) => {
  const results = await fetch(
    `${config.REST_SERVER_URL}/admin/supportingcontent/${supportingContentID}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      }, credentials: "include",
    }
  );

  const response = await results.json();
  return response;
};

export const updateSupportingContentItem = async (
  supportingContentItemID,
  data
) => {
  const results = await fetch(
    `${config.REST_SERVER_URL}/admin/supportingcontent/item/${supportingContentItemID}`,
    {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      }, credentials: "include",
      body: data,
    }
  );

  const response = await results.json();
  return response;
};

export const getLessonOutlines = async (supportingContentID) => {
  const results = await fetch(
    `${config.REST_SERVER_URL}/admin/supportingcontent/${supportingContentID}/fetchitems/outline`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      }, credentials: "include",
    }
  );

  const response = await results.json();
  return response;
};

export const getLessonData = async (lessonID) => {
  const results = await fetch(
    `${config.REST_SERVER_URL}/admin/supportingcontent/fetchrelateditems`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      }, credentials: "include",
      body: JSON.stringify({
        types: [
          "lesson",
          "outline",
          "lesson-quiz",
          "lesson-prompts",
          "lesson-practice",
          "lesson-screens",
        ],
        main_type: "outline",
        main_id: lessonID,
        match_key: "sequence_index",
      }),
    }
  );
  const response = await results.json();
  return response;
};
